//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFCheckboxField from '../ReduxFormComps/RFCheckboxField';
import renderTextField from '../MaterialUi/renderTextField';
import type { ContainerRowReduxSmartTextReadonlyField$Props } from './flowTypes'

const styles = {
    textFieldStyle: {
        width: '310px',
        paddingBottom: '10px'
    }
}

const checkboxOnChange=(e,props)=>{
    if (props.checkboxOnChange){
        const checkboxOnChangeFunc = props.checkboxOnChange
        const parentProps = (props.parentProps:any)
        checkboxOnChangeFunc(e,parentProps)
    }
}

const ContainerRowReduxSmartTextReadonlyField=(props:ContainerRowReduxSmartTextReadonlyField$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <Field
                    name={props.textField}
                    component={renderTextField}
                    label={props.textLabel}
                    style={props.textStyle?props.textStyle:styles.textFieldStyle}
                    type={props.textType?props.textType:'string'}
                    disabled={props.isTextDisable?props.isTextDisable:false}
                    onChange={(e)=> {
                        if (props.textOnChange){
                            props.textOnChange(e,props)
                        }
                    }}
                />
                {props.checkboxField && props.checkboxLabel?(
                    <Field name={props.checkboxField} 
                        component={RFCheckboxField} 
                        label={props.checkboxLabel}
                        onChange={(e)=>checkboxOnChange(e,props)}
                    />
                ):null}
            </div>
        </div>
    )
}

export default ContainerRowReduxSmartTextReadonlyField


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowReduxSmartTextReadonlyField.js